import { render, staticRenderFns } from "./opened.vue?vue&type=template&id=b1adf464&scoped=true"
import script from "./opened.vue?vue&type=script&lang=js"
export * from "./opened.vue?vue&type=script&lang=js"
import style0 from "./opened.vue?vue&type=style&index=0&id=b1adf464&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1adf464",
  null
  
)

export default component.exports